import { RecordingStatuses } from "@share/web-conferences/enums/RecordingStatuses";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { Notice } from "@service/components/toast/type/Notice";
import i18n from "@service/locale/i18";

//@todo return toast type
export const statusUpdateMessage = (status: RecordingStatuses): Notice | null  => {
    const text = status == RecordingStatuses.InProgress ? '' : (i18n.t('web-conferences.recordings.' + status).toString() || '');
    switch (status) {
        case RecordingStatuses.Starting:
            return { text, level: NoticeLevel.success }
            break;
        case RecordingStatuses.FailedToStart:
            return { text, level: NoticeLevel.danger }
            break;
        case RecordingStatuses.Started:
            return { text, level: NoticeLevel.success }
            break;
        case RecordingStatuses.Ended:
            return { text, level: NoticeLevel.success }
            break;
        case RecordingStatuses.Stopped:
            return { text, level: NoticeLevel.warning }
            break;
        default:
            return null;
            break;
    }
}
